/**
 * Class Files Data
 * Contains all class file contents for parsing
 */

export const classFilesData = {
  'Class 1A': `### Class 1A
- **班主任 (Class Master):** 良
- **副班主任 (Vice Class Master):** 祖
- **Subjects & Teachers:**
  - 中文: 婷
  - 戲劇: 薇
  - 普通話: 曉 
  - 英文: Fiona
  - Drama: Fiona
  - 說話/拼音: Fiona/藍
  - 數學: 廸
  - 公民: 峰
  - 科學: 永
  - 中史: 陸
  - 體育: 徐
  - 電腦: 民
  - 設技/設實: 添/添
  - 基商: 英
  - 商科/會計: 英
  - 禮藝: 森
  - 音樂: 嘉
  - **課室:** 293`,

  'Class 1B': `### Class 1B
- **班主任:** 藍
- **副班主任:** 藍
- **Subjects & Teachers:**
  - 中文: 文
  - 戲劇: Naz
  - 英文/Drama: Fiona/藍
  - 說話/拼音: Naz/Fiona
  - 數學: 廸
  - 公民: 嘉
  - 科學: 祖
  - 中史: 陸
  - 體育: 蘇
  - 電腦: 民
  - 設技/設實: 添/添
  - 基商: 珍
  - 商科/會計: 珍
  - 禮藝: 森
  - 音樂: 嘉
  - **課室:** 232`,

  'Class 1C': `### Class 1C
- **班主任:** 藍
- **副班主任:** 藍
- **Subjects & Teachers:**
  - 中文: 文
  - 戲劇: Fiona
  - 英文/Drama: Fiona
  - 說話/拼音: Fiona
  - 數學: 廸
  - 公民: 嘉
  - 科學: 永
  - 中史: 文
  - 體育: 蘇
  - 電腦: 方
  - 設技/設實: 添/添
  - 基商: 珍
  - 商科/會計: 珍
  - 禮藝: 森
  - 音樂: 嘉
  - **課室:** 331`,

  'Class 1D': `### Class 1D
- **班主任:** 藍
- **副班主任:** 藍
- **Subjects & Teachers:**
  - 中文: 學
  - 戲劇: 藍
  - 英文: Naz
  - 說話/拼音: Naz
  - 數學: 廸
  - 公民: 長
  - 科學: 玉
  - 中史: 文
  - 體育: 蘇
  - 電腦: 方
  - 設技/設實: 添/添
  - 基商: 珍
  - 商科/會計: 珍
  - 禮藝: 鄭
  - 音樂: 嘉
  - **課室:** 333`,

  'Class 2A': `### Class 2A
- **班主任:** 廣
- **副班主任:** 男
- **Subjects & Teachers:**
  - 中文: 廣
  - 戲劇: 廣
  - 英文: Naz
  - 說話/拼音: Naz
  - 數學: 明
  - 公民: 峰
  - 科學: 玉
  - 中史: 英
  - 體育: 徐
  - 電腦: 建
  - 設技/設實: 添/添
  - 基商: 珍
  - 商科/會計: 珍
  - 禮藝: 鄭
  - 音樂: 嘉
  - **課室:** 432`,

  'Class 2B': `### Class 2B
- **班主任:** 男
- **副班主任:** 廣
- **Subjects & Teachers:**
  - 中文: 男
  - 戲劇: 廣
  - 英文: Naz
  - 說話/拼音: Fiona
  - 數學: 廸
  - 公民: 長
  - 科學: 廣
  - 中史: 英
  - 體育: 蘇
  - 電腦: 建
  - 設技/設實: 添/添
  - 基商: 英
  - 商科/會計: 英
  - 禮藝: 鄭
  - 音樂: 嘉
  - **課室:** 342`,

  'Class 2C': `### Class 2C
- **班主任:** 峰
- **副班主任:** 廣
- **Subjects & Teachers:**
  - 中文: 峰
  - 戲劇: 廣
  - 英文: Fiona
  - 說話/拼音: Fiona
  - 數學: 廸
  - 公民: 峰
  - 科學: 祖
  - 中史: 英
  - 體育: 蘇
  - 電腦: 涂
  - 設技/設實: 添/添
  - 基商: 英
  - 商科/會計: 英
  - 禮藝: 森
  - 音樂: 建
  - **課室:** 331`,

  'Class 2D': `### Class 2D
- **班主任:** 峰
- **副班主任:** 廣
- **Subjects & Teachers:**
  - 中文: 峰
  - 戲劇: 廣
  - 英文: Fiona
  - 說話/拼音: Fiona
  - 數學: 伍
  - 公民: 峰
  - 科學: 伍
  - 中史: 英
  - 體育: 蘇
  - 電腦: 涂
  - 設技/設實: 添/添
  - 基商: 英
  - 商科/會計: 英
  - 禮藝: 森
  - 音樂: 建
  - **課室:** 431`,

  'Class 3A': `### Class 3A
- **班主任:** 峰
- **副班主任:** 男
- **Subjects & Teachers:**
  - 中文: 峰
  - 戲劇: 廣
  - 英文: Fiona
  - 說話/拼音: Fiona
  - 數學: 廸
  - 公民: 長
  - 科學: 井
  - 中史: 英
  - 體育: 徐
  - 電腦: 廣
  - 設技/設實: 添/添
  - 基商: 珍
  - 商科/會計: 珍
  - 禮藝: 森
  - 音樂: 嘉
  - **課室:** 502`,

  'Class 3B': `### Class 3B
- **班主任:** 峰
- **副班主任:** 男
- **Subjects & Teachers:**
  - 中文: 訊
  - 戲劇: 男
  - 英文: Fiona
  - 說話/拼音: Fiona
  - 數學: 廸
  - 公民: 嘉
  - 科學: 井
  - 中史: 英
  - 體育: 蘇
  - 電腦: 廣
  - 設技/設實: 添/添
  - 基商: 珍
  - 商科/會計: 珍
  - 禮藝: 森
  - 音樂: 嘉
  - **課室:** 604`,

  'Class 3C': `### Class 3C
- **班主任:** 訊
- **副班主任:** 男
- **Subjects & Teachers:**
  - 中文: 訊
  - 戲劇: 廣
  - 英文: Fiona
  - 說話/拼音: Fiona
  - 數學: 鳳
  - 公民: 嘉
  - 科學: 永
  - 中史: 英
  - 體育: 徐
  - 電腦: 民
  - 設技/設實: 添/添
  - 基商: 珍
  - 商科/會計: 珍
  - 禮藝: 森
  - 音樂: 嘉
  - **課室:** 605`,

  'Class 3D': `### Class 3D
- **班主任:** 訊
- **副班主任:** 男
- **Subjects & Teachers:**
  - 中文: 訊
  - 戲劇: 廣
  - 英文: 住
  - 說話/拼音: 住
  - 數學: 井
  - 公民: 嘉
  - 科學: 玉
  - 中史: 英
  - 體育: 蘇
  - 電腦: 民
  - 設技/設實: 添/添
  - 基商: 珍
  - 商科/會計: 珍
  - 禮藝: 森
  - 音樂: 嘉
  - **課室:** 603`,

  'Class 4A': `### Class 4A
- **班主任:** 男
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 男若営
  - 英文: 藍住営
  - 戲劇/說話: 藍Naz住営
  - 數學M1: 陸
  - 公社: 林
  - 物理: (空)
  - 化學: 玉
  - 生物: (空)
  - 中史: 陸
  - 教學: 徐
  - 體適/體急: 徐凰
  - 音通: 民
  - 電腦/技本: (空)
  - 設技/設實: (空)
  - 經濟: (空)
  - 全方/會計: 珍
  - 禮藝: 鄭
  - 音樂: 嘉
  - **課室:** 703`,

  'Class 4B': `### Class 4B
- **班主任:** 男
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 男若営
  - 英文: 域
  - 戲劇/說話: 域
  - 數學M1: 振
  - 公社: 長
  - 物理: 明
  - 化學: (空)
  - 生物: 井
  - 中史: (空)
  - 教學: 徐
  - 體適/體急: 敏
  - 音通: (空)
  - 電腦/技本: 臺城增上
  - 設技/設實: 鄭鄭上
  - 經濟: 新
  - 全方/會計: 珍
  - 禮藝: 鄭
  - 音樂: 嘉
  - **課室:** 704`,

  'Class 4C': `### Class 4C
- **班主任:** 敏
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 敏
  - 英文: 域
  - 戲劇/說話: 域
  - 數學: 建
  - 公社: 峰
  - 物理: (空)
  - 化學: (空)
  - 生物: (空)
  - 中史: (空)
  - 教學: (空)
  - 體適/體急: 蘇
  - 音通: (空)
  - 電腦/技本: (空)
  - 設技/設實: (空)
  - 經濟: (空)
  - 全方/會計: (空)
  - 禮藝: (空)
  - 音樂: 嘉
  - **課室:** 705`,

  'Class 4D': `### Class 4D
- **班主任:** 廣
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 廣
  - 英文: 藍Naz営譽
  - 戲劇/說話: 藍Naz営譽
  - 數學: 陸
  - 公社: 峰
  - 物理: 榮
  - 化學: 伍
  - 生物: 永
  - 中史: 英
  - 教學: 蘇
  - 體適/體急: 蘇徐
  - 音通: 民民
  - 電腦/技本: 臺城添增
  - 設技/設實: 鄭
  - 經濟: 鄭新
  - 全方/會計: 威
  - 禮藝: 森
  - 音樂: (空)
  - **課室:** 706`,

  'Class 5A': `### Class 5A
- **班主任:** 廣吉営
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 廣吉営
  - 英文: 域
  - 戲劇/說話: 域
  - 數學: 振建
  - 公社: 峰
  - 物理: 榮
  - 化學: (空)
  - 生物: (空)
  - 中史: (空)
  - 教學: (空)
  - 體適/體急: 蘇徐
  - 音通: 廣
  - 電腦/技本: (空)
  - 設技/設實: (空)
  - 經濟: (空)
  - 全方/會計: (空)
  - 禮藝: (空)
  - 音樂: (空)
  - **課室:** 609`,

  'Class 5B': `### Class 5B
- **班主任:** 廣
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 廣
  - 英文: 域
  - 戲劇/說話: 域
  - 數學: 井
  - 公社: 林
  - 物理: 榮
  - 化學: (空)
  - 生物: 永
  - 中史: (空)
  - 教學: (空)
  - 體適/體急: 蘇
  - 音通: (空)
  - 電腦/技本: (空)
  - 設技/設實: 鄭新
  - 經濟: 鄭新
  - 全方/會計: 上
  - 禮藝: 鄭
  - 音樂: (空)
  - **課室:** 610`,

  'Class 5C': `### Class 5C
- **班主任:** 廣
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 廣
  - 英文: 域
  - 戲劇/說話: 域
  - 數學: 明
  - 公社: 林
  - 物理: 榮
  - 化學: (空)
  - 生物: (空)
  - 中史: (空)
  - 教學: (空)
  - 體適/體急: 蘇
  - 音通: (空)
  - 電腦/技本: (空)
  - 設技/設實: (空)
  - 經濟: (空)
  - 全方/會計: (空)
  - 禮藝: (空)
  - 音樂: (空)
  - **課室:** 611`,

  'Class 5D': `### Class 5D
- **班主任:** 逸
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 逸
  - 英文: 辉Fiona藍
  - 戲劇/說話: 辉Fiona藍
  - 數學: 陸煞
  - 公社: 長
  - 物理: 榮
  - 化學: 玉
  - 生物: 永
  - 中史: (空)
  - 教學: (空)
  - 體適/體急: 凰徐
  - 音通: 民
  - 電腦/技本: 臺涂增
  - 設技/設實: (空)
  - 經濟: 新
  - 全方/會計: 緩
  - 禮藝: 鄭
  - 音樂: (空)
  - **課室:** 612`,

  'Class 6A': `### Class 6A
- **班主任:** 男
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 男
  - 英文: 住敏
  - 戲劇/說話: 住敏
  - 數學: 陸
  - 公社: 長
  - 物理: (空)
  - 化學: (空)
  - 生物: (空)
  - 中史: 英
  - 教學: (空)
  - 體適/體急: 蘇徐
  - 音通: (空)
  - 電腦/技本: (空)
  - 設技/設實: (空)
  - 經濟: (空)
  - 全方/會計: (空)
  - 禮藝: (空)
  - 音樂: (空)
  - **課室:** 417`,

  'Class 6B': `### Class 6B
- **班主任:** 文
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 文
  - 英文: 辉
  - 戲劇/說話: 辉
  - 數學: 振
  - 公社: 峰
  - 物理: 榮
  - 化學: (空)
  - 生物: 永
  - 中史: (空)
  - 教學: (空)
  - 體適/體急: 凰徐
  - 音通: 增民
  - 電腦/技本: 臺涂增
  - 設技/設實: (空)
  - 經濟: (空)
  - 全方/會計: (空)
  - 禮藝: 鄭
  - 音樂: (空)
  - **課室:** 433`,

  'Class 6C': `### Class 6C
- **班主任:** 敏
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 敏
  - 英文: 域
  - 戲劇/說話: 域
  - 數學: 廣
  - 公社: 林
  - 物理: (空)
  - 化學: (空)
  - 生物: (空)
  - 中史: (空)
  - 教學: (空)
  - 體適/體急: (空)
  - 音通: (空)
  - 電腦/技本: (空)
  - 設技/設實: (空)
  - 經濟: (空)
  - 全方/會計: (空)
  - 禮藝: (空)
  - 音樂: (空)
  - **課室:** 207`,

  'Class 6D': `### Class 6D
- **班主任:** 住敏
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 住敏
  - 英文: 住敏
  - 戲劇/說話: 住敏
  - 數學: 組
  - 公社: 林
  - 物理: (空)
  - 化學: (空)
  - 生物: (空)
  - 中史: (空)
  - 教學: (空)
  - 體適/體急: 凰
  - 音通: (空)
  - 電腦/技本: (空)
  - 設技/設實: (空)
  - 經濟: (空)
  - 全方/會計: (空)
  - 禮藝: (空)
  - 音樂: (空)
  - **課室:** 208`,

  'Class 6E': `### Class 6E
- **班主任:** 廣峯
- **副班主任:** (空)
- **Subjects & Teachers:**
  - 中文: 廣峯
  - 英文: 廣峯
  - 戲劇/說話: 廣峯
  - 數學: 髮
  - 公社: 峰
  - 物理: (空)
  - 化學: (空)
  - 生物: (空)
  - 中史: (空)
  - 教學: (空)
  - 體適/體急: (空)
  - 音通: (空)
  - 電腦/技本: (空)
  - 設技/設實: (空)
  - 經濟: (空)
  - 全方/會計: (空)
  - 禮藝: (空)
  - 音樂: (空)
  - **課室:** 509`
};
